import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

/** "Diğer" sekmesi için yatay kaydırmalı alt-menü: sadece seçili bölüm görünür. */
export function MobileMoreChips({ items, active, onChange }) {
    return (
        <div className="flex gap-2 overflow-x-auto pb-1 -mx-1 px-1" data-testid="mobile-more-chips">
            {items.map(({ key, label }) => {
                const isActive = key === active;
                return (
                    <button
                        key={key}
                        data-testid={`mobile-more-chip-${key}`}
                        onClick={() => onChange(key)}
                        className={`shrink-0 rounded-full border px-3 py-1.5 text-[11px] font-medium transition-colors ${
                            isActive
                                ? 'border-emerald-500/50 bg-emerald-500/15 text-emerald-200'
                                : 'border-slate-700 bg-slate-800 text-slate-300 active:bg-slate-700'
                        }`}
                    >
                        {label}
                    </button>
                );
            })}
        </div>
    );
}

/** Mobilde ikincil analizleri katlar; masaüstünde her zaman açık (force=true → her yerde katlanır). */
export function MobileDisclosure({ title, hint, children, defaultOpen = false, isMobile, force = false, testId }) {
    const [open, setOpen] = useState(defaultOpen);
    if (!isMobile && !force) return children;
    return (
        <div className="rounded-xl border border-slate-700 bg-slate-800" data-testid={testId}>
            <button
                onClick={() => setOpen((v) => !v)}
                aria-expanded={open}
                className="w-full flex items-center justify-between gap-2 px-4 py-3 text-left"
                data-testid={`${testId}-toggle`}
            >
                <div className="min-w-0">
                    <div className="text-sm font-semibold text-slate-100">{title}</div>
                    {hint && <div className="text-[11px] text-slate-400">{hint}</div>}
                </div>
                <ChevronDown className={`h-4 w-4 shrink-0 text-slate-400 transition-transform ${open ? 'rotate-180' : ''}`} />
            </button>
            {open && <div className="px-2 pb-2 space-y-3">{children}</div>}
        </div>
    );
}
